// Product Tabs
document.addEventListener('DOMContentLoaded', function() {
  const tabs = document.querySelectorAll('.tabbed-description__tab');
  const contents = document.querySelectorAll('.tabbed-description__content');

  tabs.forEach(tab => {
    tab.addEventListener('click', function() {
      // Remove active class from all tabs and contents
      tabs.forEach(t => t.classList.remove('active'));
      contents.forEach(c => c.classList.remove('active'));

      // Add active class to clicked tab
      this.classList.add('active');

      // Show corresponding content
      const tabName = this.getAttribute('data-tab');
      document.querySelector(`.tabbed-description__content[data-content="${tabName}"]`).classList.add('active');
    });
  });
});



// Slideshow background
document.addEventListener('DOMContentLoaded', function() {
  initSlideshowBackgrounds();
});


// Also reinitialize when Shopify sections are loaded/reloaded
document.addEventListener('shopify:section:load', function() {
  initSlideshowBackgrounds();
});

function initSlideshowBackgrounds() 
{
  const slideshows = document.querySelectorAll('.slideshow, slideshow-component');
  
  // Function to update a specific slideshow's background
  function updateSlideshowBackground(slideshow) 
  {
    const slider = slideshow.querySelector('.slider, slider-component') || slideshow;
    const slides = slider.querySelectorAll('.slideshow__slide');
    
    // Modern Dawn uses aria-hidden="false" to indicate active slide
    let activeSlide = slider.querySelector('.slideshow__slide:not([aria-hidden="true"])');
    
    // Fallback to other common methods
    if (!activeSlide) 
    {
      activeSlide = slider.querySelector('.slideshow__slide.is-selected') || 
                   slider.querySelector('.slideshow__slide.is-active') ||
                   slides[0];
    }
    
    if (activeSlide) 
    {
      const bgColor = activeSlide.getAttribute('data-bg-color');
      
      if (bgColor) 
      {
        // Find the parent section
        const parentSection = slideshow.closest('.shopify-section') || slideshow.closest('section');
        
        if (parentSection) 
        {
          parentSection.style.backgroundColor = bgColor;
        }
      }
    }
  }
  

  // Set up each slideshow
  slideshows.forEach(function(slideshow) {
    
    // Initial background set
    updateSlideshowBackground(slideshow);
    
    // Watch for aria-hidden attribute changes (modern Dawn method)
    const slider = slideshow.querySelector('.slider, slider-component') || slideshow;
    const slides = slider.querySelectorAll('.slideshow__slide');
    
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.attributeName === 'aria-hidden') {
          updateSlideshowBackground(slideshow);
        }
      });
    });
    
    // Observe aria-hidden changes on each slide
    slides.forEach(function(slide) {
      observer.observe(slide, { 
        attributes: true,
        attributeFilter: ['aria-hidden']
      });
    });
    
    // Listen to button clicks
    const prevButton = slideshow.querySelector('.slider-button--prev');
    const nextButton = slideshow.querySelector('.slider-button--next');
    const dots = slideshow.querySelectorAll('.slider-counter__link');
    
    if (prevButton) {
      prevButton.addEventListener('click', function() {
        setTimeout(function() {
          updateSlideshowBackground(slideshow);
        }, 50);
      });
    }
    
    if (nextButton) {
      nextButton.addEventListener('click', function() {
        setTimeout(function() {
          updateSlideshowBackground(slideshow);
        }, 50);
      });
    }
    
    dots.forEach(function(dot) {
      dot.addEventListener('click', function() {
        setTimeout(function() {
          updateSlideshowBackground(slideshow);
        }, 50);
      });
    });
    
    // Listen for autoplay transitions
    slideshow.addEventListener('transitionend', function() {
      updateSlideshowBackground(slideshow);
    });

  });
}



// Simple Slider
class SimpleSlider {
  constructor(container) {
    this.container = container;
    this.slides = container.querySelectorAll('.slide');
    this.prevBtn = container.querySelector('.slider-button.prev');
    this.nextBtn = container.querySelector('.slider-button.next');
    this.currentSlide = 0;
    this.autoPlayInterval = null;
    
    this.init();
  }
  
  init() {
    // Event listeners for navigation
    this.prevBtn.addEventListener('click', () => this.prevSlide());
    this.nextBtn.addEventListener('click', () => this.nextSlide());

    // Cambiar imagen al hacer hover
    this.container.addEventListener('mouseenter', () => this.nextSlide());
    this.container.addEventListener('mouseleave', () => this.showSlide(0));

    // Keyboard navigation
    document.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft') this.prevSlide();
      if (e.key === 'ArrowRight') this.nextSlide();
    });
  }
  

  showSlide(index) {
    // Hide all slides
    this.slides.forEach(slide => slide.classList.remove('active'));
    
    // Show current slide
    this.slides[index].classList.add('active');
    
    this.currentSlide = index;
  }
  

  nextSlide() {
    let nextIndex = this.currentSlide + 1;
    if (nextIndex >= this.slides.length) {
      nextIndex = 0;
    }
    this.showSlide(nextIndex);
  }
  
  prevSlide() {
    let prevIndex = this.currentSlide - 1;
    if (prevIndex < 0) {
      prevIndex = this.slides.length - 1;
    }
    this.showSlide(prevIndex);
  }
  
  goToSlide(index) {
    this.showSlide(index);
  }
  
  startAutoPlay() {
    this.autoPlayInterval = setInterval(() => {
      this.nextSlide();
    }, 5000); // Change slide every 5 seconds
  }
  
  stopAutoPlay() {
    if (this.autoPlayInterval) {
      clearInterval(this.autoPlayInterval);
      this.autoPlayInterval = null;
    }
  }
}

// Initialize slider when DOM is loaded
document.addEventListener('DOMContentLoaded', function() {
  const sliderContainers = document.querySelectorAll('.simple-slider');
  sliderContainers.forEach(container => {
    new SimpleSlider(container);
  });
});